import type { CounterView, ObjectView } from '../model/table.ts';

/** Only an unambiguous, visible owned object may supply a counter's interaction. */
export function counterObject(counter: CounterView, objects: ObjectView[], field: string): ObjectView | null {
  if (!counter.key) return null;
  const matches = objects.filter(o => !o.faceDown && o.owner === counter.owner && o.fields[field] === counter.key);
  return matches.length === 1 ? matches[0]! : null;
}
